export enum PreparationTabType {
    TO_PREPARE,
    DELIVERED
}
